export default "__VITE_PUBLIC_ASSET__750ad63b__"